<template>
  <div v-if="show" class="mt-3">
    <div class="title">
      <font-awesome-icon v-if="restmaterials" icon="check" class="font-awesome-icon restmaterials-info-check"/>
      <font-awesome-icon v-if="!restmaterials" icon="times" class="font-awesome-icon restmaterials-info-times"/>
      Restmateriaal <template v-if="!restmaterials">niet </template>
      <template v-if="!isPast">meeleveren</template>
      <template v-if="isPast">meegeleverd</template>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    data() {
      return {}
    },
    computed: {
      restmaterials() {
        return this.$store.getters.orderDetails.restmaterials
      },
      isPast() {
        if (moment(this.$store.getters.orderDetails.deliveryDate).isBefore(moment())) {
          return true
        } else {
          return false
        }
      },
      show() {
        return this.$store.getters.orderDetails.restmaterials !== null
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    font-size: 1.1em;
    font-weight: bold;
  }

  .restmaterials-info-check {
    color: $green;
    margin-right: 5px;
  }
  .restmaterials-info-times {
    color: $invalid-red;
    margin-left: 2px;
    margin-right: 7.5px;
  }
</style>
